module.exports = __webpack_public_path__ + "img/men2.3a7b659a.png";